import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
	DOCUMENT_SUB_CATEGORY_FEATURE_KEY,
	DocumentSubCategoryState,
	DocumentSubCategoryPartialState,
	documentSubCategoryAdapter
} from './document-sub-category.reducer';

// Lookup the 'DocumentSubCategory' feature state managed by NgRx
export const getDocumentSubCategoryState = createFeatureSelector<
	DocumentSubCategoryPartialState,
	DocumentSubCategoryState
>(DOCUMENT_SUB_CATEGORY_FEATURE_KEY);

const { selectAll, selectEntities } = documentSubCategoryAdapter.getSelectors();

export const getDocumentSubCategoryLoaded = createSelector(
	getDocumentSubCategoryState,
	(state: DocumentSubCategoryState) => state.loaded
);

export const getDocumentSubCategoryError = createSelector(
	getDocumentSubCategoryState,
	(state: DocumentSubCategoryState) => state.error
);

export const loadingDocumentSubCategory = createSelector(
	getDocumentSubCategoryState,
	(state: DocumentSubCategoryState) => state.loaded
);

export const getAllDocumentSubCategory = createSelector(
	getDocumentSubCategoryState,
	(state: DocumentSubCategoryState) => selectAll(state)
);

export const getDocumentSubCategoryEntities = createSelector(
	getDocumentSubCategoryState,
	(state: DocumentSubCategoryState) => selectEntities(state)
);

export const getSelectedId = createSelector(
	getDocumentSubCategoryState,
	(state: DocumentSubCategoryState) => state.selectedDocumentSubCategoryId
);

export const getSelected = createSelector(
	getDocumentSubCategoryEntities,
	getSelectedId,
	(entities, selectedId) => selectedId && entities[selectedId]
);
